export class AddTypeBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  statusLid: string;
  statusName: string;
  typeName: string;
}

export class GetListBasetype {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "typeName";
  orderType: string = "asc";
  type: string = "string";
  field: string = "typeName";
  operator: string = "startswith";
  value: string = "";
  matchCase: boolean = false;
  statusLid: string | null;
}

export class WhereCondition {
  field: string = "typeName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
// ...........................................notes.........................................................................

export class AddNoteBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  date: string;
  notes: string;
  noteTypeIds: string[];
  noteTypeId: string = "00000000-0000-0000-0000-000000000000";
  employeeId: string = "00000000-0000-0000-0000-000000000000";
  agencyId: string = "00000000-0000-0000-0000-000000000000";
  user: string
}

export class GetListBasenote {
  currentpageno: number = 1;
  pageitem: number = 10;
  orderColumn: string = "notes";
  orderType: string = "asc";
  type: string = "string";
  field: string = "notes";
  operator: string = "contains";
  value: string = "";
  matchCase: boolean = false;
  statusLid: string | null;
  startDate: string;
  endDate: string;
  noteTypeId: string;
  employeeId: string;
}

export class WhereConditionnote {
  field: string = "notes";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
